import { toast } from 'react-toastify';

export abstract class HandleToasts {
    public static error(error: any, msg?: string) {
        if (msg) {
            toast.error(msg);
            return;
        }
        toast.error(error.message);
    }

    public static success(msg: any) {
        toast.success(msg);
    }
}
